import { FC } from "react"

export const ExcelIcon: FC<{ className?: string }> = ({ className = "" }) => {
  return (
    <svg
      width="18"
      height="21"
      viewBox="0 0 18 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M0.773961 2.28966L12.0864 0.674238C12.1502 0.665079 12.2153 0.669752 12.2772 0.68794C12.3391 0.706127 12.3963 0.737404 12.445 0.779651C12.4938 0.821899 12.5329 0.874129 12.5596 0.932801C12.5864 0.991474 12.6003 1.05522 12.6003 1.11972V19.8802C12.6003 19.9446 12.5864 20.0082 12.5597 20.0668C12.533 20.1254 12.494 20.1776 12.4453 20.2199C12.3967 20.2621 12.3396 20.2934 12.2778 20.3116C12.216 20.3299 12.1511 20.3347 12.0873 20.3257L0.773061 18.7102C0.558529 18.6797 0.362225 18.5727 0.220209 18.4091C0.0781927 18.2454 2.07941e-06 18.036 0 17.8193V3.18061C2.07941e-06 2.96392 0.0781927 2.75449 0.220209 2.59082C0.362225 2.42715 0.558529 2.32021 0.773061 2.28966H0.773961ZM13.5002 2.40035H17.1C17.3387 2.40035 17.5676 2.49517 17.7364 2.66394C17.9052 2.83272 18 3.06162 18 3.30031V17.6996C18 17.9383 17.9052 18.1672 17.7364 18.336C17.5676 18.5047 17.3387 18.5995 17.1 18.5995H13.5002V2.40035ZM7.38053 10.4999L9.90041 6.90013H7.74051L6.30059 8.95742L4.86066 6.90013H2.70076L5.22064 10.4999L2.70076 14.0998H4.86066L6.30059 12.0425L7.74051 14.0998H9.90041L7.38053 10.4999Z"
        fill="currentColor"
      />
    </svg>
  )
}
